import type { ImageFocus } from './types';

/**
 * Which part of a cropped photo stays in view (a section's "focus point"). A photo shown with
 * object-cover or background-size: cover is cropped to the box; by default the middle stays. A
 * portrait whose face is near the top sets 'top' so the face isn't cut off.
 */
export const IMAGE_FOCUS_VALUES: readonly ImageFocus[] = [
  'center', 'top', 'bottom', 'left', 'right', 'top left', 'top right', 'bottom left', 'bottom right',
];

/** The CSS position for a focus value; undefined for blank or anything else (the middle, as before). */
export function imageFocusPosition(focus: unknown): string | undefined {
  return typeof focus === 'string' && focus !== 'center' && (IMAGE_FOCUS_VALUES as readonly string[]).includes(focus)
    ? focus
    : undefined;
}
